// src/productImages.js
// Cache d'images produits ref → image_url depuis catalogue_produits
// Utilisé par tous les modals de dimensionnement pour enrichir les articles avec leurs photos
import { supabase } from './supabaseClient';

let imageMapCache = null;
let loadingPromise = null;

export const loadProductImages = async () => {
  if (imageMapCache) return imageMapCache;
  if (loadingPromise) return loadingPromise;

  loadingPromise = supabase
    .from('catalogue_produits')
    .select('ref, image_url')
    .not('image_url', 'is', null)
    .then(({ data, error }) => {
      if (error || !data) {
        imageMapCache = {};
        return imageMapCache;
      }
      const map = {};
      data.forEach((p) => {
        if (p.ref && p.image_url) {
        const filename = p.image_url.split('/').pop().split('?')[0];
        map[p.ref] = 'https://devis.takoussane.com/images/' + filename;
      }
      });
      imageMapCache = map;
      return map;
    });

  return loadingPromise;
};

// Lookup synchrone — renvoie null si la map n'est pas chargée ou la ref absente
export const getProductImage = (ref) => {
  if (!imageMapCache || !ref) return null;
  return imageMapCache[ref] || null;
};

// Force le rechargement (après upload/suppression d'une photo dans CatalogueManager)
export const refreshProductImages = () => {
  imageMapCache = null;
  loadingPromise = null;
  return loadProductImages();
};
